var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgCoursePositive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fillRule: "evenodd"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#009245",
    d: "M18.03 6.06l-5.162 5.88-1.996-2.275-1.97 2.243 3.964 4.515.003-.007.007.007L20 8.3z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M9.082 12.89H5.906v-.61h-.454v.61h-.3c-1.658 0-3.007-1.536-3.007-3.423s1.342-3.423 3.007-3.423h5.227v.61h.452v-.612h.3c1.658 0 3.007 1.536 3.007 3.423l-.012.268 1.88-2.134c-.69-2.318-2.612-3.99-4.872-3.99h-.3V3h-.454v.61H5.142C2.307 3.612 0 6.24 0 9.467s2.307 5.854 5.142 5.854h.3v.61h.454v-.61h5.307L9.082 12.89z",
    fill: "#010101",
    fillRule: "nonzero"
  })));
}
export default SvgCoursePositive;